module.exports = __webpack_public_path__ + "img/be.d054c238.svg";